import type React from 'react';

// Para elementos clicáveis que não são <button>: Enter ou Espaço disparam o mesmo onClick.
// Ignora teclas vindas de um filho focável (um botão dentro do card, por exemplo).
export function activateOnKey(e: React.KeyboardEvent<HTMLElement>) {
  if (e.target !== e.currentTarget) return;
  if (e.key !== 'Enter' && e.key !== ' ') return;
  e.preventDefault();
  e.currentTarget.click();
}

export const clickableProps = { role: 'button', tabIndex: 0, onKeyDown: activateOnKey } as const;
